var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-mode",class:{
        selected: _vm.isPlanningMode
    },on:{"click":_vm.setPlanningMode}},[_vm._v(" "+_vm._s(_vm.isPlanningMode?'Complete':'Plans')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }